// src/components/AccountCreation/AccountCreation.js
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom'; // Make sure to import this
import { validateToken, callApi } from "../../lib/utils";
import {
  isMobile,
  isTablet,
  isBrowser,
  browserName,
  osName,
  deviceType
} from "react-device-detect";
import { PLANS_CONFIG } from './constants';
import Stepper from './Stepper';
import Footer from './Footer';
import Step0_PlanSelection from './Step0_PlanSelection';
import Step1_SubscriptionPlan from './Step1_SubscriptionPlan';
import Step2_UserDetails from './Step2_UserDetails';
import Step3_PaymentDetails from './Step3_PaymentDetails';
import Step4_Confirmation from './Step4_Confirmation';
import Step5_Status from './Step5_Status';
import Step6_Success from './Step6_Success';
// Utility: Fire GA4 events safely
// const trackEvent = (eventName, params = {}) => {
//   if (window.gtag) {
//     window.gtag('event', eventName, params);
//     console.log("GA Event:", eventName, params); // For debugging
//   } else {
//     console.warn("Google Analytics not initialized");
//   }
// };

const deviceInfo = {
  deviceType: isMobile ? "Mobile" : isBrowser ? "Desktop" : "Tablet",
  browser: browserName,
  os: osName,
  device: deviceType === 'browser' ? 'desktop' : deviceType,
};

console.log(deviceInfo);

const AccountCreation_2 = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [isProcessing, setIsProcessing] = useState(false);
  const [status, setStatus] = useState('');
  const [apiData, setApiData] = useState(null);
  const [apiLoading, setApiLoading] = useState(false);
  const [apiError, setApiError] = useState(null);
  const [checkoutDetails, setCheckoutDetails] = useState(null);
  const [initialPlanCode, setInitialPlanCode] = useState(null);
  const [guestAccessToken, setGuestAccessToken] = useState(null);
  const [userAccessToken, setUserAccessToken] = useState(null);
  const [isPendingFlow, setIsPendingFlow] = useState(false);
  const [noPendingOrders, setNoPendingOrders] = useState(false);
  const [isActiveOrder, setIsActiveOrder] = useState(true);
  const [isCancelledSubs, setIsCancelledSubs] = useState(false);
  const [apiParams, setApiParams] = useState({
    device_type: "",
    region_code: "",
    diseasecondition_code: 'SD'
  });
  const location = useLocation();
  const [isRedirecting, setIsRedirecting] = useState(false);

  const [formData, setFormData] = useState({
    subscription: { planId: null, planName: '', frequency: '', price: 0, tierName: '', tierPlanCode: '' },
    products: [],
    user: { email: '', firstName: '', lastName: '', dateOfBirth: '', gender: '', country: '', state: '', city: '', address: '', zipcode: '', password: '' },
  });

  useEffect(() => {
    // Google Tag Manager (Script 2)
    const gtmId = 'GTM-K79JCHF';

    // Ensure dataLayer exists
    window.dataLayer = window.dataLayer || [];

    // Polyfill gtag if it doesn't exist, so existing trackEvent calls push to dataLayer safely
    if (!window.gtag) {
      function gtag() { window.dataLayer.push(arguments); }
      window.gtag = gtag;
    }

    // Check if GTM script is already added to prevent duplicates
    const existingScript = document.querySelector(`script[src*="googletagmanager.com/gtm.js?id=${gtmId}"]`);

    if (!existingScript) {
      (function (w, d, s, l, i) {
        w[l] = w[l] || []; w[l].push({
          'gtm.start':
            new Date().getTime(), event: 'gtm.js'
        }); var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
            'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', gtmId);
    }
  }, []);

  // src/components/AccountCreation/AccountCreation_2.js

  const fetchOldPlans = () => {
    setApiLoading(true);
    setApiError(null);

    // This API call fetches the user's last successful order and all currently available plans.
    callApi(`/api/orders/uportal/last-order-details`, {}, "GET")
      .then((response) => {
        if (!response.data.success) {
          setApiError(response.data.message || "Could not retrieve order details.");
          setApiLoading(false);
          return;
        }

        const data = response.data.data;
        const { latestOrder, applicableProducts } = data;

        // Store all available plans in apiData. This is needed by Step4_Confirmation
        // to display other plan options the user can switch to.
        setApiData(applicableProducts);
        setIsPendingFlow(true);

        if (!latestOrder) {
          console.log("No previous order found. Displaying available plans on confirmation screen.");

          // If no latest order, still show available plans from applicableProducts
          if (applicableProducts && applicableProducts.subscriptions?.length > 0) {
            const firstTier = applicableProducts.subscriptions[0].tiers[0];
            const firstPlan = firstTier?.plans?.[0];

            if (firstPlan) {
              setFormData(prev => ({
                ...prev,
                // subscription: {
                //   planId: firstPlan.id,
                //   planName: firstPlan.planName,
                //   frequency: firstPlan.paymentFrequency.frequency,
                //   price: firstPlan.finalPrice,
                //   tierName: firstTier.tierName,
                //   tierPlanCode: firstPlan.code
                // },
                products: applicableProducts.products || []
              }));

              // Also set apiParams for device type
              setApiParams(prev => ({
                ...prev,
                device_type: firstPlan.deviceTypeId,
              }));
            }
          }

          // Proceed directly to confirmation step
          //setCurrentStep(4);
          setNoPendingOrders(true);
          setApiLoading(false);
          return;
        }

        const subscriptionDetail = latestOrder.orderDetails?.find(detail => detail.productId === 2);
        const lastPlanCode = subscriptionDetail?.entitySubscriptionTierPlan?.code;
        const isActiveOrder = subscriptionDetail?.entitySubscriptionTierPlan?.isActive;

        if (!isActiveOrder) {
          console.log("No previous order found. Displaying available plans on confirmation screen.");

          // If no latest order, still show available plans from applicableProducts
          if (applicableProducts && applicableProducts.subscriptions?.length > 0) {
            const firstTier = applicableProducts.subscriptions[0].tiers[0];
            const firstPlan = firstTier?.plans?.[0];

            if (firstPlan) {
              setFormData(prev => ({
                ...prev,
                // subscription: {
                //   planId: firstPlan.id,
                //   planName: firstPlan.planName,
                //   frequency: firstPlan.paymentFrequency.frequency,
                //   price: firstPlan.finalPrice,
                //   tierName: firstTier.tierName,
                //   tierPlanCode: firstPlan.code
                // },
                products: applicableProducts.products || []
              }));

              // Also set apiParams for device type
              setApiParams(prev => ({
                ...prev,
                device_type: firstPlan.deviceTypeId,
              }));
            }
          }

          // Proceed directly to confirmation step
          //setCurrentStep(4);
          setNoPendingOrders(true);
          setIsActiveOrder(isActiveOrder);
          setApiLoading(false);
          return;
        }

        // MODIFIED: Only set checkoutDetails to resume payment if the last order status is 'PENDING'.
        if (latestOrder) {
          setCheckoutDetails({
            ...latestOrder.checkoutSessionDetails,
            orderId: latestOrder.id,
          });
          setInitialPlanCode(lastPlanCode);
        }

        if (lastPlanCode && applicableProducts) {
          let selectedPlan = null;
          let selectedTier = null;

          // Search through the applicableProducts to find the full details of the user's last plan
          applicableProducts.subscriptions[0]?.tiers.forEach(tier => {
            const foundPlan = tier.plans.find(p => p.code === lastPlanCode);
            if (foundPlan) {
              selectedPlan = foundPlan;
              selectedTier = tier;
            }
          });

          // if (latestOrder && latestOrder.checkoutSessionDetails) {
          //   setCheckoutDetails(
          //     latestOrder.status === 'PROCESSING'
          //       ? { ...latestOrder.checkoutSessionDetails, orderId: latestOrder.id }
          //       : latestOrder.checkoutSessionDetails
          //   );
          //   setInitialPlanCode(latestOrder.checkoutSessionDetails.tierPlanCode);
          // }

          // if (latestOrder && latestOrder.checkoutSessionDetails && applicableProducts) {
          //   // Get the plan code from the user's last order (e.g., "ANDROID_BRONZE_MONTHLY")
          //   const lastPlanCode = latestOrder.checkoutSessionDetails.tierPlanCode;

          //   let selectedPlan = null;
          //   let selectedTier = null;

          //   // Search through the applicableProducts to find the full details of the user's last plan
          //   applicableProducts.subscriptions[0]?.tiers.forEach(tier => {
          //     const foundPlan = tier.plans.find(p => p.code === lastPlanCode);
          //     if (foundPlan) {
          //       selectedPlan = foundPlan;
          //       selectedTier = tier;
          //     }
          //   });

          if (selectedPlan && selectedTier) {
            // Populate the formData state with the details of the last order.
            // This is the data that will be displayed on the confirmation screen.
            setFormData(prev => ({
              ...prev,
              subscription: {
                planId: selectedPlan.id,
                planName: selectedPlan.planName,
                frequency: selectedPlan.paymentFrequency.frequency,
                price: selectedPlan.finalPrice,
                tierName: selectedTier.tierName,
                tierPlanCode: selectedPlan.code
              },
              products: applicableProducts.products || [],
              // IMPORTANT: The last-order-details API does not return user profile info.
              // You would need a separate API call to a '/api/user/profile' endpoint
              // to get the user's name, DOB, address, etc., to display here.
            }));

            // Also update apiParams to reflect the device type from the last order.
            setApiParams(prev => ({
              ...prev,
              device_type: selectedPlan.deviceTypeId,
            }));

          } else {
            setApiError("Could not match your last order with any available plans.");
          }
        }
        // else {
        //   setApiError("No previous order details were found.");
        // }
      })
      .catch((err) => {
        console.error("Error fetching last order details: ", err);
        setApiError("Failed to load your last order details.");
      })
      .finally(() => {
        setApiLoading(false);
      });
  };

  useEffect(() => {
    if (window.location.pathname === '/new/order/return') {
      setIsRedirecting(true);
      window.location.href = 'https://smart-monitor.com/thank-you/';
      // trackEvent('purchase', {
      //   transaction_id: checkoutDetails?.orderId || 'N/A',
      //   value: formData.subscription.price,
      //   currency: 'USD',
      //   items: [{
      //     item_id: formData.subscription.planId,
      //     item_name: formData.subscription.planName,
      //     item_category: formData.subscription.tierName,
      //     price: formData.subscription.price,
      //   }]
      // });
      return;
    }
    // Access the passed state from the location object
    const passedState = location.state;
    console.log("passedState...", passedState)
    if (passedState) {
      // Destructure patientData for easier mapping
      const {
        firstName,
        lastName,
        email,
        dateOfBirth,
        gender,
        country,
        state,
        city,
        address,
        zipCode // Note: The key is zipCode (camelCase) in the source data
      } = passedState.userProfileData;

      // Update the formData state with the received user profile
      setFormData(prev => ({
        ...prev,
        user: {
          ...prev.user,
          firstName: firstName || '',
          lastName: lastName || '',
          email: email || '',
          dateOfBirth: dateOfBirth || '',
          gender: gender || '',
          country: country || '',
          state: state || '',
          city: city || '',
          address: address || '',
          zipcode: zipCode || '' // Map zipCode to the 'zipcode' field in your state
        }
      }));
      setIsCancelledSubs(passedState.isCancelledSubs);
      fetchOldPlans();
      setCurrentStep(4);
    }
  }, [location.state]); // Add location.state as a dependency

  useEffect(() => {
    let accountId, authKey;
    accountId = process.env.REACT_APP_SM_ACCOUNT_ID;
    authKey = process.env.REACT_APP_SM_AUTH_KEY;

    const authPayload = {
      accountId,
      authKey,
      issueRefreshToken: false
    };

    callApi('/ng/v1/auth', authPayload, 'POST')
      .then(response => {
        setGuestAccessToken(response.data.data.accessToken);
      })
      .catch(err => {
        console.error("Auth failed:", err);
        setApiError("Authentication failed. Please try again later.");
      })
      .finally(() => {
        setApiLoading(false);
      });
  }, []);

  // useEffect(() => {
  //   if (!guestAccessToken) return;

  //   const fetchPlans = () => {
  //     setApiLoading(true);
  //     setApiError(null);
  //     const { device_type, region_code, diseasecondition_code } = apiParams;

  //     const headers = { 'Authorization': `Bearer ${guestAccessToken}` };
  //     console.log("headers....", headers)
  //     callApi(`/api/public/orders/uportal/applicable-products?device_type=${device_type}&region_code=${region_code}&diseasecondition_code=${diseasecondition_code}`, {}, "GET", headers)
  //       .then((response) => {
  //         const data = response.data.data;
  //         setApiData(data);

  //         const firstTier = data?.subscriptions?.[0]?.tiers?.[0];
  //         const firstPlan = firstTier?.plans?.[0];
  //         //const firstPlan = firstTier?.plans.find(p => p.deviceTypeId === apiParams.device_type);


  //         if (firstPlan) {
  //           setFormData(prev => ({
  //             ...prev, subscription: {
  //               planId: firstPlan.id,
  //               planName: firstPlan.planName,
  //               frequency: firstPlan.paymentFrequency.frequency,
  //               price: firstPlan.finalPrice,
  //               tierName: firstTier.tierName,
  //               tierPlanCode: firstPlan.code
  //             },
  //             products: data.products || []
  //           }));
  //         }
  //         else {
  //           setFormData(prev => ({ ...prev, subscription: { planId: null, planName: '', frequency: '', price: 0, tierName: firstTier?.tierName || '', tierPlanCode: firstTier.code || '' }, products: data.products || [] }));
  //         }
  //       })
  //       .catch((err) => {
  //         console.log("err: ", err);
  //         setApiError("Failed to load subscription plans.");
  //       })
  //       .finally(() => {
  //         setApiLoading(false);
  //       });
  //   };

  //   fetchPlans();
  // }, [apiParams, guestAccessToken]);

  const handleFetchPlans = () => {
    //  if (apiData && apiData.subscriptions && apiData.subscriptions.length > 0) {
    //         nextStep();
    //         return;
    //     }

    setApiLoading(true);
    setApiError(null);
    const { device_type, region_code, diseasecondition_code } = apiParams;
    if (!device_type || !region_code) return;

    const headers = { 'Authorization': `Bearer ${guestAccessToken}` };

    callApi(`/api/public/orders/uportal/applicable-products?device_type=${device_type}&region_code=${region_code}&diseasecondition_code=${diseasecondition_code}`, {}, "GET", headers)
      .then((response) => {
        const data = response.data.data;
        setApiData(data);

        const firstTier = data?.subscriptions?.[0]?.tiers?.[0];
        const firstPlan = firstTier?.plans?.[0];
        //const firstPlan = firstTier?.plans.find(p => p.deviceTypeId === apiParams.device_type);


        if (firstPlan) {
          setFormData(prev => ({
            ...prev, subscription: {
              planId: firstPlan.id,
              planName: firstPlan.planName,
              frequency: firstPlan.paymentFrequency.frequency,
              price: firstPlan.finalPrice,
              tierName: firstTier.tierName,
              tierPlanCode: firstPlan.code
            },
            products: data.products || []
          }));
          nextStep();
        }
        else {
          setFormData(prev => ({ ...prev, subscription: { planId: null, planName: '', frequency: '', price: 0, tierName: firstTier?.tierName || '', tierPlanCode: firstTier.code || '' }, products: data.products || [] }));
        }
      })
      .catch((err) => {
        console.log("err: ", err);
        setApiError("Failed to load subscription plans.");
      })
      .finally(() => {
        setApiLoading(false);
      });
  };

  const nextStep = () => {
    const stepNames = [
      "Select Region",
      "Select Plan",
      "Verify Email & Create Profile",
      "Confirm",
      "Payment"
    ];

    if (currentStep < 5) {
      const currentStepName = stepNames[currentStep - 1];
      // trackEvent('order_step', {
      //   step_number: currentStep,
      //   step_name: currentStepName,
      // });
      setCurrentStep(currentStep + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const resetWorkflow = () => {
    setApiParams({ device_type: "", region_code: "", diseasecondition_code: 'SD' });
    //setCurrentStep(1);
    //setStatus('');
  };

  const renderStep = () => {
    const props = {
      data: formData,
      setData: setFormData,
      nextStep: nextStep,
      prevStep: prevStep,
      handleFetchPlans: handleFetchPlans,
      accessToken: userAccessToken || guestAccessToken, // Use user token if available, otherwise guest token
      setUserAccessToken: setUserAccessToken,
      isPendingFlow: isPendingFlow,
      isCancelledSubs: isCancelledSubs,
      //trackEvent: trackEvent,
      deviceInfo: deviceInfo
      // setUserAccessToken: (token) => {
      //   setUserAccessToken(token);
      //   // Store token in session storage to survive the Stripe redirect
      //   sessionStorage.setItem('userAccessToken', token);
      // }
    };
    switch (currentStep) {
      case 1: return <Step0_PlanSelection {...props} apiData={apiData} setApiParams={setApiParams} apiParams={apiParams} apiLoading={apiLoading} apiError={apiError} />;
      case 2: return <Step1_SubscriptionPlan {...props} apiData={apiData} setApiParams={setApiParams} apiParams={apiParams} apiLoading={apiLoading} apiError={apiError} />;
      case 3: return <Step2_UserDetails {...props} apiParams={apiParams} />;
      case 4: return <Step4_Confirmation {...props} apiParams={apiParams} guestAccessToken={guestAccessToken} apiData={apiData} apiLoading={apiLoading} apiError={apiError} noPendingOrders={noPendingOrders} setNoPendingOrders={setNoPendingOrders} isActiveOrder={isActiveOrder} />;
      case 5: return <Step3_PaymentDetails {...props} checkoutDetails={checkoutDetails} initialPlanCode={initialPlanCode} />;
      case 6: return <Step6_Success status={'success'} reset={resetWorkflow} />; //<Step5_Status status={'success'} reset={resetWorkflow} />;
      default: return <Step0_PlanSelection {...props} />;
    }
  };

  // const steps = ["Select Region", "Select Plan", "Verify Email & Create Profile", "Confirm", "Payment"];
  // UPDATED: The steps array now includes icon classes
  const steps = [
    { label: "Select Region", icon: "bi-globe" },
    { label: "Select Plan", icon: "bi-card-checklist" },
    { label: "Verify Email & Create Profile", icon: "bi-person-plus" },
    { label: "Confirm", icon: "bi-check2-circle" },
    { label: "Payment", icon: "bi-credit-card" }
  ];

  if (isRedirecting) {
    return (
      <div className="d-flex justify-content-center align-items-center bg-light" style={{ minHeight: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Redirecting...</span>
        </div>
        <h4 className="ms-3">Redirecting to confirmation page...</h4>
      </div>
    );
  }

  return (
    <>
      <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/font/bootstrap-icons.css" />

      <div className="bg-light d-flex flex-column align-items-center pt-3 pt-md-5 px-3" style={{ minHeight: "94vh", paddingBottom: "2em" }}>
        <div className="col-12 col-lg-8 col-xl-8">
          <div className="card shadow-lg border-0" style={{ position: 'relative' }}>
            {isProcessing && (<div className="position-absolute w-100 h-100 d-flex justify-content-center align-items-center bg-white bg-opacity-75 rounded" style={{ zIndex: 10 }}><div className="spinner-border text-primary" role="status"><span className="visually-hidden">Loading...</span></div></div>)}
            <div className="card-body p-4 p-md-5 card-body-height">
              {currentStep <= steps.length && (<Stepper currentStep={currentStep} steps={steps} />)}
              {renderStep()}
            </div>
          </div>
        </div>
      </div>
      <Footer />

      {/* <div className="bg-light min-vh-100 d-flex flex-column align-items-center p-2 p-sm-3 p-md-4">
        <div className="container" style={{ maxWidth: '900px' }}>
            <div className="card shadow-sm border-0">
              <div className="card-body p-3 p-md-5">
                {isProcessing && (<div className="position-absolute w-100 h-100 d-flex justify-content-center align-items-center bg-white bg-opacity-75 rounded" style={{ zIndex: 10 }}><div className="spinner-border text-primary" role="status"><span className="visually-hidden">Loading...</span></div></div>)}
                {currentStep <= steps.length && <Stepper currentStep={currentStep} steps={steps} />}
                {renderStep()}
              </div>
            </div>
        </div>
      </div> */}

    </>
  );
};

export default AccountCreation_2;
